:host {
    display: flex;
    align-items: center;
    box-sizing: border-box;
}

.rs-radio__circle-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 23PX;
    height: 23PX;
    box-shadow: inset 0 0 0 1PX var(--rs-color-grey-light);
    border-radius: 50%;
    cursor: pointer;
    max-width: 23PX;
    max-height: 23PX;
    min-width: 23PX;
    min-height: 23PX;
    box-sizing: border-box;
}

.rs-radio__circle-inner {
    background-color: var(--rs-color-black);
    width: 13PX;
    height: 13PX;
    border-radius: 50%;
    transform: scale3d(0, 0, 0);
    transition: transform 0.2s ease-out;
    max-width: 13PX;
    max-height: 13PX;
    min-width: 13PX;
    min-height: 13PX;
}

:host(.radio-checked) .rs-radio__circle-inner {
    transform: scale3d(1, 1, 1);
}

:host(.radio-disabled) {
    cursor: not-allowed;
    opacity: 0.5;
}

::slotted([slot='start']) {
    margin-right: 11px;
}

::slotted([slot='end']) {
    margin-left: 11px;
}

:host([button="vertical"]) ::slotted([slot="start"]) {
    margin-right: 0;
    margin-bottom: 11px;
}

:host([button="vertical"]) ::slotted([slot="end"]) {
    margin-left: 0;
    margin-top: 11px;
}

:host(.radio-button.radio-checked) {
    box-shadow: inset 0 0 0 2px var(--rs-color-primary);
}

:host(.radio-button) {
    display: flex;
    padding: 15px;
    box-shadow: inset 0 0 0 1px var(--rs-color-grey-light);
    border-radius: 6px;
    cursor: pointer;
    transition: box-shadow 0.4s ease-out;
}

:host(.radio-button:hover) {
    box-shadow: inset 0 0 0 2px var(--rs-color-primary);
}

:host(.radio-button--vertical) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

:host(.radio-button--horizontal) {
    flex-direction: row;
    align-items: center;
    justify-content: start;
    text-align: left;
}